/**
 * Module identifiers. Mirrors the tap-api MODULES list so the manifest can
 * activate/deactivate features per deployment without code changes.
 */
export const MODULE_NAME = {
  HEALTH: 'health',
  AUTH: 'auth',
  USERS: 'users',
  ROLES: 'roles',
  PERMISSIONS: 'permissions',
  TENANTS: 'tenants',
  PARTNERS: 'partners',
  ASSETS: 'assets',
  GATEWAYS: 'gateways',
  TAGS: 'tags',
  ALARMS: 'alarms',
  NOTIFICATIONS: 'notifications',
  DASHBOARDS: 'dashboards',
  REPORTS: 'reports',
  CONNECTORS: 'connectors',
  AUDIT: 'audit',
  SETTINGS: 'settings',
} as const

export type ModuleName = (typeof MODULE_NAME)[keyof typeof MODULE_NAME]
